import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";
import { enableLocalAuthBypass } from "./app/local-auth-bypass";
import { environment, LOCAL_SKIP_AUTH } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

// Local dev only (`ng serve --configuration=local`): fake a signed-in session before the app
// boots, so the auth guard, header and permission checks all see a user. In dev/prod builds
// LOCAL_SKIP_AUTH is false and enableLocalAuthBypass is an empty function.
if (LOCAL_SKIP_AUTH) {
  enableLocalAuthBypass();
}

// zone.js is loaded via the "polyfills" entry in angular.json.
// provideZoneChangeDetection() must stay: Angular 22's bootstrapModule defaults to zoneless,
// and this app relies on Zone.js to trigger change detection after async work.
platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch(err => console.error(err));
